module.exports = __webpack_public_path__ + "images/bannerFR-358f2b01e01c00914fc7a2dc29483043.jpg";